var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('app-header'),_c('app-bar',{attrs:{"app":""}}),_c('v-main',{staticClass:"mb-4 white"},[_c('router-view',{staticClass:"animate__animated animate__slideInLeft animate__faster"})],1),_c('footer-nav')],1)}
var staticRenderFns = []

export { render, staticRenderFns }